export interface InsuranceCompany {
  name: string;
  code: InsuranceCompanyEnum;
  numericCode: number;
  csFullName: string;
}

export enum InsuranceCompanyEnum {
  Vzp = 'VZP',
  Vozp = 'VOZP',
  Cpzp = 'CPZP',
  Ozp = 'OZP',
  Zps = 'ZPS',
  Zpmv = 'ZPMV',
  Rbp = 'RBP',
  Other = 'OTHER'
}
